<template lang="pug">
  div
    slot(name="title")
    div.round-xl.neutral300.pa-4
      div.text-xs.font-semibold.neutral700--text Select preferred time
      v-select.round-xl.custom-select-style.mt-2(v-model="selectedSlot" :items="slots" :disabled="disabled" @change="selectSlot(selectedSlot)" placeholder="Select time" background-color="neutral100" :loading="loading" attach dense outlined hide-details="auto" append-icon="$yzi-chevron-down" :menu-props="{ offsetY: true, rounded: 'lg', contentClass: 'select-menu', maxHeight: 200 }" height="48")
        template(#selection="{ item }")
          div {{ item.time | displayTime2 }}
        template(#item="{ item, on, attrs }")
          v-list-item(v-on="on" :class="(selectedSlot && selectedSlot.time === item.time) ? 'neutral300' : ''")
            v-list-item-content
              v-list-item-title
                div
                  .text-sm.neutral700--text {{ item.time | displayTime2 }}
                  .text-sm.neutral500--text {{ item.dates.length }} of {{ slotDates.length }} dates available
      template(v-if="selectedSlot")
        div.round-xl.pa-3.mt-4(v-if="allDateAvailable" :style="availableBorder")
          div.d-flex.align-center
            v-icon.mr-2(color="success500" size="18") $yzi-check-circle
            div.text-sm.font-medium.neutral700--text All services and providers are available
          div.text-sm.neutral700--text You can edit the timinig
          div.d-flex.align-center.justify-end
            y-button.mt-3(label="Edit" outlined size="sm" @click="openSelectTimeDialog()")
        div.round-xl.pa-3.mt-4(v-else :style="unavailableBorder")
          div.d-flex.align-center
            v-icon.mr-2(color="danger500" size="18") $yzi-alert-circle
            div.text-sm.font-medium.neutral700--text {{ selectedSlot.dates.length }} of {{ slotDates.length }} {{ selectionTimeText }}
          div.text-sm.neutral700--text Finish your selection or you can re-select time.
          div.d-flex.align-center.justify-end
            y-button.mt-3(label="Finish your selection" outlined size="sm" @click="openSelectTimeDialog()")
    div.d-flex.align-center.my-3
      v-divider.neutral400
      div.text-sm.font-semibold.neutral500--text.mx-3 OR
      v-divider.neutral400

    y-button(label="Select time for individual dates" size="sm" :disabled="disabled" :loading="loading" underline button-class="px-0" @click="openSelectTimeDialog()")
    template(v-if="!selectedSlot")
      div(style="padding: 50px;")

    .dialogs
      set-preferred-time-dialog(v-if="showSelectTimeDialog" :open.sync="showSelectTimeDialog")
    
</template>

<script>
import { mapGetters } from 'vuex'
import SetPreferredTimeDialog from '@/components/clinic/appointment/advance/SetPreferredTimeDialog.vue'

export default {
  components: { SetPreferredTimeDialog },
  props: {
    value: {
      type: Object,
      default: (() => {})
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showSelectTimeDialog: false,
      recurrences: null,
      selectedSlot: null,
      totalMinutes: 0,
      slotDates: [],
      slots: [],
      availableBorder: {
        border: '2px solid var(--v-success500)',
        background: '#EEFCE9',
        borderRadius: '8px',
        padding: '2px'
      },
      unavailableBorder: {
        border: '2px solid var(--v-warning500)',
        background: '#FFFAE6',
        borderRadius: '8px',
        padding: '2px'
      }
    }
  },
  computed: {
    ...mapGetters({ appointmentDetails: 'clinic/getTempAppointmentDetails' }),
    allDateAvailable () {
      let availability = null
      if (this.appointmentDetails.sessions.length) {
        if (this.slotDates.length && this.slotDates.length === this.appointmentDetails.sessions.filter(f => (f.start || f.set_later)).length) {
          availability = true
        } else {
          availability = false
        }
      }
      return availability
    },
    selectionTimeText () {
      let text = 'appointments are set.'
      if (!this.appointmentDetails.sessions.filter(f => f.set_later).length) {
        let times = this.appointmentDetails.sessions.filter(f => f.start).map(m => m.start.substr(-8))
        let sameTime = true
        const firstElement = times[0]
          for (let i = 1; i < times.length; i++) {
            if (times[i] !== firstElement) {
              sameTime = false
            }
          }
        if (sameTime) {
          text = `appointments set at ${this.$options.filters.displayTime2(firstElement)}`
        }
      }
      return text
    }
  },
  watch: {
    appointmentDetails: {
      deep: true,
      handler (val) {
        if (val.recurring_data && Object.keys(val.recurring_data).length) {
          this.recurrences = val.recurring_data.recurrences
          this.totalMinutes = val.recurring_data.total_min
          this.slotDates = val.recurring_data.dates
          this.slots = val.recurring_data.options
        }
      }
    },
    selectedSlot: {
      deep: true,
      handler (val) {
        if (val) {
          this.$emit('input', val)
        }
        this.$emit('change', val) 
      }
    },
    value (val) {
      if (!val) {
        this.selectedSlot = null
      }
    }
  },
  methods: {
    openSelectTimeDialog () {
      this.showSelectTimeDialog = true
    },
    selectSlot (slot) {
      if (slot) {
        this.$emit('input', slot)
      }
      this.$emit('change', slot) 
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .custom-select-style .v-input__icon {
    min-width: 22px;
    width: 22px;
    margin-top: 4px;
  }
}
</style>